import { Controller } from "@hotwired/stimulus"
import {
  Chart,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Filler,
  Tooltip,
  Legend,
} from "chart.js"

Chart.register(
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Filler,
  Tooltip,
  Legend,
)

// data-controller="visits-chart"
// data-visits-chart-labels-value='["1 Jan", "2 Jan", ...]'
// data-visits-chart-datasets-value='[{"label":"Gym A","data":[1,2,3,...]}, ...]'
export default class extends Controller {
  static values = {
    labels: Array,
    datasets: Array,
  }

  connect() {
    const canvas = this.element.querySelector("canvas") || this.element
    this.chart = new Chart(canvas.getContext("2d"), {
      type: "line",
      data: {
        labels: this.labelsValue,
        datasets: this.datasetsValue.map((ds, i) => ({
          label: ds.label,
          data: ds.data,
          borderColor: this.colorForIndex(i),
          backgroundColor: this.colorForIndex(i) + "20",
          fill: true,
          tension: 0.3,
        })),
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            mode: "index",
            intersect: false,
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              stepSize: 1,
            },
          },
        },
        interaction: {
          mode: "nearest",
          axis: "x",
          intersect: false,
        },
      },
    })
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }

  colorForIndex(i) {
    const colors = [
      "#3b82f6",
      "#ef4444",
      "#22c55e",
      "#f59e0b",
      "#8b5cf6",
      "#ec4899",
      "#06b6d4",
      "#84cc16",
    ]
    return colors[i % colors.length]
  }
}
